import React, { useContext, useEffect, useState } from 'react';
import AppContext from '../../AppContext';
import { useParams } from 'react-router-dom';
// import QuickSightDashboard from '../../components/QuickSightDashboard/QuicksightDashboard';
import QuickSightDashboard2 from '../../components/QuickSightDashboard/QuicksightDashboard2';


const DashboardView = ({ dashboardId: configuredDashboardId } = {}) => {

    const { apiKey, availableDashboards, setMenuTitle, embedContext, realTime } = useContext(AppContext);

    const params = useParams();
    // const [dashboardId, setDashboardId] = useState(availableDashboards?.filter((y) => (!!y.url && y.url === params?.dashboardId) || y.key === params?.dashboardId)[0]?.key)
    // const [dashboardTitle, setDashboardTitle] = useState(availableDashboards?.filter((y) => (!!y.url && y.url === params?.dashboardId) || y.key === params?.dashboardId)[0]?.text)
    // const [dashboardType, setDashboardType] = useState(availableDashboards?.filter((y) => (!!y.url && y.url === params?.dashboardId) || y.key === params?.dashboardId)[0]?.type)

    const activeDashboardId = configuredDashboardId ?? params?.dashboardId;
    const [selectedDashboard, setSelectedDashboard] = useState();

    useEffect(() => {
        if(!!params?.dashboardId && availableDashboards?.length >0) {
            // console.log('availableDashboards: ', availableDashboards);
            const dashboard = availableDashboards.find(
                (y) =>
                    (!!y.url && y.url === activeDashboardId) ||
                    y.key === activeDashboardId
            );
            setSelectedDashboard(dashboard)
            // setDashboardId(dashboard?.key);
            // setDashboardType(dashboard?.type);
            // !!dashboard?.text && setDashboardTitle(dashboard?.text);
            if (dashboard?.text) {
                setMenuTitle(dashboard.text);
            }
        }

    }, [activeDashboardId, availableDashboards, setMenuTitle]);
    
    if (!selectedDashboard) {
        return null;
    }

    return (
        <QuickSightDashboard2
            key={selectedDashboard.key}
            dashboardId={selectedDashboard.key}
            dashboardTitle={selectedDashboard.text}
            dashboardType={selectedDashboard.type}
            dashboardSubtype={selectedDashboard?.subType || ""}
            apiKey={apiKey}
            realTime={realTime}
            embedContext={embedContext}
            singleSheet={import.meta?.env?.VITE_HIDETABS === "true"}
        />
    );
    //eslint-disable-next-line
    // let whatever = import.meta.env;

    // return <QuickSightDashboard2 
    //     key={selectedDashboard.key}
    //     dashboardId={selectedDashboard.key} 
    //     dashboardTitle={selectedDashboard.text}
    //     dashboardType={selectedDashboard.type}
    //     dashboardSubtype={selectedDashboard?.subType || ""}
    //     apiKey={apiKey}
    //     realTime={realTime}
    //     embedContext={embedContext}
    //     singleSheet={import.meta?.env?.VITE_HIDETABS ==="true" ? true : false}
    // />
};

export default DashboardView;